export default {
	APPLICATIONS: 'companies/:company_id/applications/',
	APPLICATION_REJECT: 'companies/:company_id/applications/reject/',
	APPLICATION_ADD_TO_LEASE: 'companies/:company_id/applications/add-to-lease/',
	APPLICATION_CONFIG_IMPORT: 'companies/:company_id/applications/import-config/'
}
